import { z } from 'zod';

export const EmployeeSearchSchema = z.object({
  status: z.enum(['all', 'active', 'on_leave', 'retired']).default('active'),
  department: z.string().optional(),
  pageSize: z.number().default(50),
  pageIndex: z.number().default(0),
});

export type EmployeeSearchParams = z.infer<typeof EmployeeSearchSchema>;
